export default "__VITE_ASSET__DFOCsiiA__"